import { render, staticRenderFns } from "./CarModelSelector.vue?vue&type=template&id=4665f7f6"
import script from "./CarModelSelector.vue?vue&type=script&lang=ts"
export * from "./CarModelSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports